<ng-container *ngIf="selectedParcels$ | async as selectedParcels">
  <div class="scrolling-panel-container">
    <h2>{{ readOnlyMap ? 'VIEW' : 'FIND' }} YOUR PROPERTY</h2>

    <div *ngIf="!kmlUploaded && !readOnlyMap" class="instruction-container">
      <div class="instruction-title">Select your parcel(s) on the map</div>
      <div class="instruction-body">Click on your parcel(s) to continue.</div>
      <div class="instruction-body">
        Having issues? Click
        <a target="_blank" rel="noopener noreferrer" href="/help">here for help.</a>
      </div>
    </div>

    <div *ngIf="kmlUploaded" class="instruction-container">
      <div class="instruction-title">
        Your uploaded file has been used to identify the boundaries of your property. You can select additional parcels
        before proceeding.
      </div>
    </div>

    <div *ngFor="let selectedParcel of selectedParcels; index as i">
      <div class="parcel-info-container">
        <fc-parcel-info [parcel]="selectedParcel" [readOnly]="readOnlyMap" [isAdmin]="isAdmin"></fc-parcel-info>
      </div>
    </div>
  </div>

  <mat-card appearance="outlined" class="bottom-container">
    <div class="button-container">
      <div (click)="handleBackLink()" class="link-container fc-link">
        <fa-icon [icon]="['far', 'arrow-left']" class="blue size-20"></fa-icon>
        Back
      </div>
      <button
        (click)="checkRegions()"
        *ngIf="!readOnlyMap"
        class="button"
        color="primary"
        data-cy="select-parcels-confirm-button"
        disabled="{{ selectedParcels.length < 1 }}"
        mat-raised-button
        type="button">
        {{ isAdmin ? 'Update' : 'Confirm' }} Parcel(s)
      </button>
    </div>
  </mat-card>
</ng-container>
